<template>
  <center>
    <h1>404</h1>

    <h1>Sayfa Bulunamadı!</h1>
    <p style="font-size: xx-large">
      <a v-if="this.realm != null" href="/dashboard">Özet Sayfasına Git.</a>
      <a v-else>Giriş yapmak istediğiniz linki kontrol ediniz!</a>
    </p>
  </center>
</template>
  
<script>
import authStore from "@/store/modules/auth";

export default {
  name: "NotFound",
  data() {
    return {
      realm: authStore.state.realm,
    };
  },
};
</script>
  
<style scoped>
center {
  margin: 15vw;
}

h1 {
  color: var(--border);
  font-size: 6em;
}
</style>